export default __webpack_public_path__ + "static/media/spinner-solid.ed39c4e7.svg";